import Marquee from "react-fast-marquee";

const items = [
  "Gardez votre voiture",
  "Réduisez vos dépenses carburant",
  "Solutions sur mesure",
  "Service de proximité",
  "Paiement en plusieurs fois possible",
];

export default function MarqueeStrip() {
  return (
    <div className="border-y border-white/10 bg-[#2E3336] py-5 overflow-hidden" data-testid="marquee-strip">
      <Marquee speed={35} gradient={false}>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-display text-2xl sm:text-4xl mx-6 ${i % 2 === 0 ? "text-white/90" : "text-outline"}`}>
              {item}
            </span>
            <span className="text-[#6EB000] text-xl mx-2">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
